// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fallback-spinner {
  position: relative;
  display: flex;
  height: 100vh;
  width: 100%;
}
.loading {
  position: absolute;
  left: calc(50% - 35px);
  top: 50%;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 3px solid transparent;
}
.effect-1,
.effect-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid #2962ff;
  border-radius: 50%;
  box-sizing: border-box;
}

.effect-1 {
  animation: rotate 1s ease infinite;
}
.effect-2 {
  animation: rotateOpacity 1s ease infinite 0.1s;
}
.effect-3 {
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid #2962ff;
  animation: rotateOpacity 1s ease infinite 0.2s;
  border-radius: 50%;
  box-sizing: border-box;
}

.loading .effects {
  transition: all 0.3s ease;
}
.fallback-logo {
  position: absolute;
  left: calc(50% - 45px);
  top: 40%;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}
@keyframes rotateOpacity {
  0% {
    transform: rotate(0deg);
    opacity: 0.1;
  }
  100% {
    transform: rotate(1turn);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/spinner/spinner.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAElB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAElB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAE9B,8CAA8C;EAC9C,kBAAkB;EAElB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,wBAAwB;EAC1B;AACF;AACA;EACE;IAEE,uBAAuB;IACvB,YAAY;EACd;EACA;IAEE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".fallback-spinner {\r\n  position: relative;\r\n  display: flex;\r\n  height: 100vh;\r\n  width: 100%;\r\n}\r\n.loading {\r\n  position: absolute;\r\n  left: calc(50% - 35px);\r\n  top: 50%;\r\n  width: 55px;\r\n  height: 55px;\r\n  border-radius: 50%;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n  border: 3px solid transparent;\r\n}\r\n.effect-1,\r\n.effect-2 {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 3px solid transparent;\r\n  border-left: 3px solid #2962ff;\r\n  border-radius: 50%;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.effect-1 {\r\n  animation: rotate 1s ease infinite;\r\n}\r\n.effect-2 {\r\n  animation: rotateOpacity 1s ease infinite 0.1s;\r\n}\r\n.effect-3 {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 3px solid transparent;\r\n  border-left: 3px solid #2962ff;\r\n  -webkit-animation: rotateOpacity 1s ease infinite 0.2s;\r\n  animation: rotateOpacity 1s ease infinite 0.2s;\r\n  border-radius: 50%;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.loading .effects {\r\n  transition: all 0.3s ease;\r\n}\r\n.fallback-logo {\r\n  position: absolute;\r\n  left: calc(50% - 45px);\r\n  top: 40%;\r\n}\r\n\r\n@keyframes rotate {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(1turn);\r\n    transform: rotate(1turn);\r\n  }\r\n}\r\n@keyframes rotateOpacity {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n    opacity: 0.1;\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(1turn);\r\n    transform: rotate(1turn);\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
